import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>&copy; 2024 mochi534</p>
        </footer>
    );
};

export default Footer;
